
const CustomDataTypes = {
    APP_APPID_PMDB: 'PMDB',
    APP_APPID_NLW: 'nlw',
    APP_APPID_MARYTV: 'marytv',
    APP_APPID_ANT: 'ant',
    APP_APPID_ERTU: 'ertu',
    APP_APPID_TRANSCODER1: 'transcoder1',
    APP_APPID_OKNO: "okno",
    APP_APPID_FCPWORKS: "fcpworks",
    APP_APPID_STANDARDGROUP: "standardgroup",
    APP_APPID_MOTORVISION: "motorvision",
    APP_APPID_FRANCETV: "francetv",
    APP_APPID_SYNOLOGY: "synology",
    EXPERTSEARCH: "Expertensuche",
    ADVANCED_METADATA: 'advancedData',
    HELP_EMAIL: 'help@pmdb-support.de',
    UPLOAD_FORM: "UploadForm",
    SEARCH_FORM: "SearchForm",
    MASTER_UPLOAD_FORM: "MasterClipUpload",
    APP_FORM_SEARCH: 'search',
    APP_FORM_UPLOAD: 'upload',
    ADD_FORM: "addDataForm",
    DATE_FORMAT: "d.MM.yyyy",
    DELETE: 'delete',
    EDIT: 'edit',
    UPLOAD: 'upload',
    DOWNLOAD: 'download',
    ROLE_LEVEL0: 'level0',
    ROLE_LEVEL1: 'level1',
    ROLE_LEVEL2: 'level2',
    ROLE_LEVEL3: 'level3',
    ROLE_LEVEL4: 'level4',
    ROLE_LEVEL5: 'level5',
    ROLE_LEVEL6: 'level6',
    ROLE_LEVEL7: 'level7',
    ROLE_LEVEL8: 'level8',
    // GRANTING_NAME_STATUS: 'status',
    GRANTING_VALUE_STATUS: 'vorbereitung',
    RIGHTS_NOTEMP: 'notemp',
    RIGHTS_NOLOCAL: 'nolocal',
    RIGHTS_NOMEDIA: 'nomedia',
    EDIT_STATUS: 'edit_status',
    EDIT_PUBlISHED: 'edit_published',
    EDIT_PUBlISHED_YES: 'edit_published_yes',
    EDIT_PUBlISHED_NO: 'edit_published_no',
    RIGHTS_FIELD: 'rechte_flags',
    ANIMATION_CGI: 'flags',
    MASTER_UPLOAD: 'mediafileupload',
    MASTER_DELETE: 'mediafiledelete',
    API_COUNTRIES: 'rechte_einschraenkunglokal',
    DATE: 'date',
    USER: 'user',
    ACTION: 'action',
    PROJECT_BORDER_ACTIVE: "2px solid red",
    PROJECT_BORDER: "1px solid #ccc",
    SINGLEPROJECT_BTN_ID: "projectbtid",
    SINGLEROOM_BTN_ID: "roombtid",
    TEXT: 'text',
    TITLE: 'title',
    ACTIONS: 'actions',
    LANG: 'videolanguages',
    THUMB: 'thumbnail',
    STATUS: 'status',
    UNLIMITED: 'notemp;nolocal;nomedia',
    UPLOAD_DATE: 'uploaddate',
    SORTING: 'id|DESC',
    SORT_DEFAULT: 'created|DESC',
    ID: 'id',
    CLIPID: 'clipid',
    CUTID: 'cutid',
    PAGE_ICON_COLOR: { color: '#d5001c' },
    PAGE_ICON_STYLE: { color: '#d5001c', fontSize: '18.72px' },
    BORDER_RED: { border: 'solid 1px red' },
    WIDTH_FULL: { width: '100%', border: 'none' },
    BUTTON_ICON: { marginRight: "5px", fontSize: "14px" },
    SORT_CREATED: 'created',
    SORT_PRODATE: 'rechte_produktionsdatum',
    APP_CLIPID_FIELDS: ["id", "clipid"],
    APP_CREATED_FIELDS: ["created", "upload_date", "uploaddate"],
    APP_PROD_DATE_FIELDS: ["rechte_produktionsdatum", "production_date"],
    SUB_SCRIPT: "sub",
    SUP_SCRIPT: "sup",
    HTML_TAGS: ["</", "/>", "&nbsp;"],
    SUB_SCRIPT_OBJECTS: ["CO2", "H2O"],
    SUB_SCRIPT_FIELDS: ["description_de", "title"],
    VIEW_GRID: 'grid',
    VIEW_LIST: 'list',
    COLOR_RED: '#d5001c',
    COLOR_BLACK: '#000',
    SORT_MEDIA: "media",
    PROFILE_PAGE: 'profilepage',
    CONTACT_PAGE: 'contactpage',
    COLOR_TEXT: "#5d5959",
    COLOR_TEXT_DARK: "#5d5959",
    COLOR_TEXT_LIGHT: "#aaa",
    HEADING_1: "18px",
    AUTO_CLOSE_TIME: 3000,
    SHOW_ANALYTICS: 'analytics',
    API_PMDBUSER: 'txt4',
    API_YEAR: 'year',
    API_CREATEDBY: 'createdby',
    API_PROJECT: 'project',
    API_ROOM: 'room',
    API_TAGS: 'tags',
    API_PARENTSERIES: '_series_parent_program',
    API_SERIES_PARENT: '_series_parent',
    API_PROGRAMORSERIES: 'programorseries',
    GUI_SERIES_PROGRAM: 'Parent Series',
    GUI_SERIES_SERIES: 'Program',
    GUI_SERIES_SEASON: 'Series',
    MW_SERIES_PROGRAM: 'series_program',
    MW_SERIES_SERIES: 'series_series',
    MW_SERIES_SEASON: 'series_season',
    API_MODELS: 'modelle',
    TAGS_FILE: "porschetags",
    MODELS_FILE: "porschemodelle",
    SEARCH_LEN: 3,
    MIN_ROWS: 1,
    MAX_ROWS: 40,
    CONFIG_FILE: true,
    FLEX_APP: true,
    STAR: "*",
    CUSTOM_TEMPLATE_FIELD: {
        api: false,
        condition: {
            ext: { name: "customdisplay", value: "customdisplay" },
            name: "customdisplay",
            value: "customdisplay"
        },
        data: [],
        inputType: "CustomDropDown",
        lgMsId: "data.defaultName",
        name: "dafaultName"
    },
    CUSTOM_CONDITION: { name: "customdisplay", value: "customdisplay", ext: { name: "customdisplay", value: "customdisplay" } },
    UPLOAD_INTO_MASTER: "Upload Into Master",
    MASTER_UPLOAD_STYLE: { minWidth: '1100px', height: '75vh', minHeight: '700px', width: '60vw' },
    EXPERTSEARCH_STYLE: { width: '78%', height: '92vh', left: '15%', top: '60px' },
    CUSTOM_IMG_TYPE: "tiff;jpeg;gif;png;jpg;webp;psd;raw;bmp;heif;indd;jpeg 2000;",
    CUSTOM_VIDEO_TYPE: "webm;mpg;mp2;mpeg;mpe;mpv;ogg;mp4;m4p;m4v;avi;wmv;mov;qt;flv;swf;avchd",
    CUSTOM_DOCUMENT_TYPE: "pdf;doc;docx;html;htm;odt;xls;xlsm;xlsx;ppt;pptx;txt;ods;xml",
    CUSTOM_AUDIO_TYPE: "wv;wma;webm;wav;vox;voc;tta;sln;rf64;raw;ra;rm;opus;ogg;oga;mogg;nsf;nmf;msv;mpc;mp3;mmf;m4p;m4b;m4a;ivs;iklax;gsm;flac;dvf;dss;dct;cda;awb;au;ape;amr;alac;aiff;act;aax;aac;aa;8svx;3gp",
    CUSTOM_LARGE_TEXT: {
        boxSizing: "border-box",
        "-webkit-text-fill-color": "rgb(85, 85, 85)",
        color: "rgb(85, 85, 85)",
        display: "inline-block",
        fontFamily: "PorscheNextTT-Regular",
        fontSize: "16px",
        overflowX: "hidden",
        overflowY: "hidden",
        textCverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        border: "none",
        background: "transparent",
        cursor: "pointer"
    },

    CUSTOM_VIEWLIST: "viewListItems",
    CUSTOM_TITLE_PERCENT: "35%",
    CUSTOM_MEDIA_PERCENT: "10%",
    CUSTOM_ACTIONS_PERCENT: "5%",
    CUSTOM_MFLIST: "mediafileItems",
    REPORTSGROUP: "reportandreload",
    CUSTOM_ADMINPAGE: "adminPageItems",
    CUSTOM_ADMINTABS: "adminPageTabs"
}

export default CustomDataTypes;